<template>
  <div class="scroll-container" style="margin-top: 70px;position: relative;">
    <div class="bagcode-color" ref="bagcodeRef" :style="{  background: bannerList[0].bagcode_color}"></div>
    <div ref="banner" class="banner-box" v-show="bannerList.length > 0" >
      <swiper
        class="banner"
        v-if="bannerList.length > 0"
        :options="swiperOption"
        @slide-change="onSlideChange"
        ref="mySwiper"
      >
        <div class="swiper-slide" v-for="item in bannerList" :key="item.id" >

     
          
          <a :href="item.link_content" v-if="item.link_type == 1">
            <div
              class="slider-item"
              :style="{ backgroundImage: 'url(' + item.banner_img2 + ')' }"
            ></div>
          </a>
          <router-link
            :to="{ name: 'CourseShow', params: { id: item.link_content } }"
            v-else-if="item.link_type == 2"
          >
            <div
              class="slider-item"
              :style="{ backgroundImage: 'url(' + item.banner_img2 + ')' }"
            ></div>
          </router-link>
          <router-link
            :to="{ name: 'NewsShow', params: { id: item.link_content } }"
            v-else-if="item.link_type == 3"
          >
            <div
              class="slider-item"
              :style="{ backgroundImage: 'url(' + item.banner_img2 + ')' }"
            ></div>
          </router-link>
          <router-link
            :to="{ name: 'GoodsDetail', params: { id: item.link_content } }"
            v-else-if="item.link_type == 4"
          >
            <div
              class="slider-item"
              :style="{ backgroundImage: 'url(' + item.banner_img2 + ')' }"
            ></div>
          </router-link>
          <router-link
            :to="{ name: 'LibraryDetail', params: { id: item.link_content } }"
            v-else-if="item.link_type == 5"
          >
            <div
              class="slider-item"
              :style="{ backgroundImage: 'url(' + item.banner_img2 + ')' }"
            ></div>
          </router-link>
          <router-link
            :to="{ name: 'EbooksDetail', params: { id: item.link_content } }"
            v-else-if="item.link_type == 6"
          >
            <div
              class="slider-item"
              :style="{ backgroundImage: 'url(' + item.banner_img2 + ')' }"
            ></div>
          </router-link>
          <router-link
            :to="{ name: 'ClassesDetail', params: { id: item.link_content } }"
            v-else-if="item.link_type == 7"
          >
            <div
              class="slider-item"
              :style="{ backgroundImage: 'url(' + item.banner_img2 + ')' }"
            ></div>
          </router-link>
          <div
            class="slider-item"
            :style="{ backgroundImage: 'url(' + item.banner_img2 + ')' }"
            v-else-if="item.link_type == 0"
          ></div>
        </div>
        <div
          class="swiper-pagination"
          slot="pagination"
          v-if="bannerList.length > 1"
        ></div>
        <div
          class="swiper-button swiper-button-next"
          slot="button-prev"
          v-if="bannerList.length > 1"
        ></div>
        <div
          class="swiper-button swiper-button-prev"
          slot="button-next"
          v-if="bannerList.length > 1"
        ></div>
      </swiper>
    </div>
    <div v-if="bannerList.length == 0" class="empty"></div>
  
      
    
    <div
      class="section"
      v-for="(rec, index) in recommendList"
      :class="{
        'head-index': index == 0,
      }"
      :key="index"
    >
      <div
        class="headBox"
        v-if="
          rec.list.length !== 0 ||
          (rec.channel_info.type == 18 && rec.channel_info.is_first_show == 1)
        "
        :class="{
          'title-course': rec.channel_info.type == 1,
          'title-tea': rec.channel_info.type == 3,
        }"
      >
        <div class="title">
          {{ rec.channel_info.name }}
        </div>
        <template
          v-if="rec.channel_info.show_more == 1 && rec.list.length !== 0"
        >
          <template
            v-if="
              rec.channel_info.type == 1 ||
              rec.channel_info.type == 11 ||
              rec.channel_info.type == 12
            "
          >
            <router-link
              v-if="
                rec.channel_info.show_more_url == 1 ||
                rec.channel_info.type == 11 ||
                rec.channel_info.type == 12
              "
              class="more more-course"
              :class="{ 'more-course-rich': $store.state.template == 'rich' }"
              :to="{
                name: 'IndexRecommendCourse',
                query: {
                  recommend: rec.channel_info.id,
                  title:
                    rec.channel_info.type == 1 || rec.channel_info.type == 11
                      ? ''
                      : rec.channel_info.name,
                },
              }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
            <router-link
              v-else
              class="more more-course"
              :class="{ 'more-course-rich': $store.state.template == 'rich' }"
              :to="{ name: 'Course' }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
          </template>
          <template v-else-if="rec.channel_info.type == 3">
            <router-link
              v-if="rec.channel_info.show_more_url == 1"
              class="more more-teacher"
              :to="{
                name: 'IndexRecommendTeacher',
                query: {
                  recommend: rec.channel_info.id,
                  title: rec.channel_info.name,
                },
              }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
            <router-link
              v-else
              class="more more-teacher"
              :to="{ name: 'ShowTeachers' }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
          </template>
          <template v-else-if="rec.channel_info.type == 7">
            <router-link
              v-if="rec.channel_info.show_more_url == 1"
              class="more more-goods"
              :to="{
                name: 'IndexRecommendGoods',
                query: {
                  recommend: rec.channel_info.id,
                  title: rec.channel_info.name,
                },
              }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
            <router-link v-else class="more more-goods" :to="{ name: 'Goods' }">
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
          </template>
          <template v-else-if="rec.channel_info.type == 8">
            <router-link
              v-if="rec.channel_info.show_more_url == 1"
              class="more more-goods"
              :to="{
                name: 'IndexRecommendPeriods',
                query: {
                  recommend: rec.channel_info.id,
                  title: rec.channel_info.name,
                },
              }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
            <router-link
              v-else
              class="more more-goods"
              :to="{ name: 'Periods' }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
          </template>
          <template v-else-if="rec.channel_info.type == 9">
            <router-link
              v-if="rec.channel_info.show_more_url == 1"
              class="more more-goods"
              :to="{
                name: 'IndexRecommendPackage',
                query: {
                  recommend: rec.channel_info.id,
                  title: rec.channel_info.name,
                },
              }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
            <router-link
              v-else
              class="more more-goods"
              :to="{ name: 'Package' }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
          </template>
          <template v-else-if="rec.channel_info.type == 6">
            <router-link
              v-if="rec.channel_info.show_more_url == 1"
              class="more more-news"
              :to="{
                name: 'IndexRecommendNews',
                params: { id: rec.channel_info.id },
                query: { title: rec.channel_info.name },
              }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
            <router-link v-else class="more more-news" :to="{ name: 'News' }">
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
          </template>
          <template v-else-if="rec.channel_info.type == 5">
            <router-link
              v-if="rec.channel_info.show_more_url == 1"
              class="more more-public"
              :to="{
                name: 'IndexRecommendCourse',
                query: {
                  type: 4,
                  recommend: rec.channel_info.id,
                  title: rec.channel_info.name,
                },
              }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
            <router-link
              v-else
              class="more more-public"
              :to="{ name: 'OpenCourse', query: { type: 5 } }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
          </template>
          <template v-else-if="rec.channel_info.type == 10">
            <router-link
              v-if="rec.channel_info.show_more_url == 1"
              class="more"
              :to="{
                name: 'IndexRecommendClasses',
                query: {
                  type: 4,
                  recommend: rec.channel_info.id,
                  title: rec.channel_info.name,
                },
              }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
            <router-link
              v-else
              class="more more-public"
              :to="{ name: 'Classes' }"
            >
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
          </template>
          <template v-else-if="rec.channel_info.type == 17">
            <router-link class="more more-ebooks" :to="{ name: 'Ebooks' }">
              查看更多
              <i class="el-icon-arrow-right" />
            </router-link>
          </template>
        </template>
      </div>
      <div class="items advert" v-html="rec.channel_info.details"></div>
      <RecommendCoupon
        :recommend="rec.list"
        v-if="rec.channel_info.type == 19"
        class="items-t"
      ></RecommendCoupon>
      <RecommendTeacher
        :recommend="rec.list"
        v-if="rec.channel_info.type == 3"
        class="items-t"
      ></RecommendTeacher>
      <NewsHome
        v-else-if="rec.channel_info.type == 6"
        :recommend="rec.list"
      ></NewsHome>
      <div
        v-else
        class="items clearfix"
        :class="'items-' + rec.channel_info.type"

        style="display: flex; overflow-x: auto;"
      >
        <template v-for="(item, index) in rec.list.slice(0,4)">
          <RichPublicItem
            v-if="rec.channel_info.type == 5"
            :key="index"
            :course="item"
          ></RichPublicItem>
          <RichCourseItem
            class="recommend-course-rich"
            v-if="
              rec.channel_info.type == 1 ||
              rec.channel_info.type == 11 ||
              rec.channel_info.type == 12
            "
            :key="index"
            :course="item"
            from="index"
          ></RichCourseItem>
          <GoodsItem
            v-if="rec.channel_info.type == 7"
            :key="index"
            :item="item"
          ></GoodsItem>
          <PeriodsItem
            v-else-if="rec.channel_info.type == 8"
            :key="index"
            :item="item"
          ></PeriodsItem>
          <PackageItem
            v-else-if="rec.channel_info.type == 9"
            :key="index"
            :item="item"
          ></PackageItem>
          <ClassesItem
            v-else-if="rec.channel_info.type == 10"
            :key="index"
            :item="item"
          ></ClassesItem>

          <EbooksItem
            v-else-if="rec.channel_info.type == 17"
            :key="item.id"
            :item="item"
          ></EbooksItem>
        </template>
      </div>
    </div>
   
  </div>
</template>
<script>
import RichCourseItem from "../components/rich/CourseItem.vue";
import RecommendTeacher from "../components/recommend/RecommendTeacher.vue";
import RecommendCoupon from "../components/recommend/RecommendCoupon.vue";
import GoodsItem from "@/components/GoodsItem.vue";
import RichPublicItem from "../components/rich/PublicCourseItem.vue";
import NewsHome from "../components/rich/NewsHome.vue";
import PeriodsItem from "../components/periods/PeriodsItem.vue";
import PackageItem from "../components/package/PackageItem.vue";
import ClassesItem from "../components/classes/ClassesItem.vue";
import EbooksItem from "@/components/EbooksItem.vue";

export default {
  name: "Index",
  components: {
    GoodsItem,
    RichCourseItem,
    RichPublicItem,
    NewsHome,
    RecommendTeacher,
    RecommendCoupon,
    PeriodsItem,
    PackageItem,
    ClassesItem,
    EbooksItem,
  },
  data() {
    return {
      openCourses: [],
      openCourseItmes: [],
      openCoursePage: 1,
      currentTeacherIndex: 0,
    };
  },
  computed: {
    // banner参数
    swiperOption() {
      return {
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        loop: this.bannerList.length > 1,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      };
    },
    currentTeacher() {
      let recommend = this.recommendList.filter(
        r => r.channel_info.type == 3,
      )[0];
      if (!recommend) {
        return;
      }
      return recommend.list[this.currentTeacherIndex];
    },
    bannerList() {
      return this.$store.state.indexData.bannerList;
    },
    recommendList() {
      return this.$store.state.indexData.recommendList;
    },
  },
  methods: {
    onSlideChange(){

      const index =  this.$refs.mySwiper.swiper.realIndex

      this.$refs.bagcodeRef.style.background = this.bannerList.length>0 && this.bannerList[index].bagcode_color
      

    },
    getScrollWidth() {
      let noScroll,
        scroll,
        oDiv = document.createElement("DIV");
      oDiv.style.cssText =
        "position:absolute; top:-1000px; width:100px; height:100px;";
      noScroll = document.body.appendChild(oDiv).clientWidth;
      oDiv.style.overflowY = "scroll";
      scroll = oDiv.clientWidth;
      document.body.removeChild(oDiv);
      return noScroll - scroll;
    },
  },
  mounted() {
    // this.$kefu()
    this.$nextTick(() => {
      // let scrollWidth = this.getScrollWidth();
      // let scrollWidth = window.outerWidth;
      // this.$refs.banner.style.height ="calc((100vw - " + scrollWidth + "px) * 460 / 1920";
      // this.$refs.banner.style.height = 340 + "px";
    });
  },
};
</script>
<style lang="scss" scoped>

.bagcode-color{
  position: absolute;
  width: 100%;
  // height: 100px;
  left:calc(-1*(100vw - 1200px)/2);
  // height: 340px;
  aspect-ratio: 1200/340;
  padding-right: calc(100vw - 1200px);
}

  
@media only screen and (min-device-width: 520px) and (max-device-width: 1024px) {
  /* 平板样式调整 */
  .bagcode-color{
    display: none;
  }
  .banner-box {
    width: 1200px;
    
  }
}



.banner {
  height: 100%;
  overflow: hidden;


  &:hover {
    .swiper-button {
      display: block;
    }
  }
  .swiper-slide{
    width: 100%;
    aspect-ratio: 1200/340;
  }
  .slider-item {
    height: 100%;
    width: 100%;
    // aspect-ratio: 10/2.8;
    margin: 0 auto;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .swiper-button {
    width: 30px;
    height: 40px;
    position: absolute;
    background-size: 100% 100%;
    z-index: 9999;
    display: none;
  }

  .swiper-button-prev {
    background-image: url("~@/assets/images/index/banner-left@2x.png");
    left: 5%;
  }

  .swiper-button-next {
    background-image: url("~@/assets/images/index/banner-right@2x.png");
    right: 5%;
  }
}
.empty {
  height: 70px;
}
.shadow {
  box-shadow: 0px 6px 20px 0px rgba(65, 105, 255, 0.04),
    0px 13px 33px 0px rgba(0, 0, 0, 0.04) !important;
  transition: all 0.5s !important;
  background: white;
  background-color: white;

  &:hover {
    box-shadow: 0px 11px 55px 10px rgba(0, 0, 0, 0.07),
      0px 13px 18px -8px rgba(0, 0, 0, 0.15) !important;
  }
}

.head-index {
  margin-top: 32px;
}

.section {
  /*overflow: hidden;*/
  .headBox {
    padding-bottom: 22px;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-items: center;
    height: 36px;
    .title {
      font-size: 22px;
      font-weight: 500;
      color: #333;
      line-height: 22px;
      text-align: center;
      display: flex;
      align-items: center;
    }
    .title::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 22px;
      background: $primary-color-hover;
      border-radius: 4px;
      margin-right: 10px;
    }
    .title-course {
      margin-bottom: 40px;
    }

    .title-tea {
      margin-bottom: 24px;
    }
  }
  .items {
    width: 100%;
    margin: 0 auto;
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;

  }
  .items::-webkit-scrollbar {
    display: none;
  }

  .advert {
    width: 100% !important;
    /deep/ img {
      max-width: 100%;
    }
  }
  .items-5,
  .items-t {
    padding-bottom: 32px;
  }

  .items-10,
  .items-1,
  .items-9,
  .items-11 {
    margin-bottom: 8px;
  }

  .more {
    display: block;
    width: 104px;
    height: 36px;
    background: #efefef;
    border-radius: 21px;
    box-sizing: border-box;
    font-size: 14px;
    color: #999999;
    line-height: 36px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-arrow-right {
      font-weight: 700;
    }
    &:hover {
      background: $primary-color;
      color: white;
      border-color: $primary-color;
    }
  }

  // .more-course-rich {
  //   margin-top: 3px;
  // }

  // .more-goods {
  //   // margin-top: 12px;
  // }

  // .more-teacher {
  //   margin-top: 0;
  // }

  // .more-public {
  //   margin-top: 0;
  // }
}

.sec-odd {
  background-color: white;
}

.recommend-course {
  /deep/ {
    .course-title {
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      font-size: 22px;
    }
  }

  &:hover::before {
    display: none;
  }
}
</style>
